<mat-tab-group>
  <mat-tab label="Competenza" *ngIf="datiCompetenza">
    <div class="page-padding">
      <h1 class="centered-title">Dettaglio Competenza: {{ datiCompetenza.descrizione }}</h1>

      <div class="content-section">
        <div class="section-title-wrapper">
          <h2 class="section-title">Informazioni sulla Competenza</h2>
          <div class="competence-badges-inline">
            <span *ngIf="datiCompetenza.green" class="competence-badge green-badge-custom">Green</span>
            <span *ngIf="datiCompetenza.digital" class="competence-badge green-badge-custom">Digitale</span>
          </div>
        </div>
        <p>{{ datiCompetenza.informazioniCompetenza }}</p>
        <p><strong>Livello EQF: {{ datiCompetenza.eqfCompetenza }}</strong></p>
      </div>

      <div class="content-section"
           *ngIf="(classificazioniAda?.length > 0) || (classificazioniIstat?.length > 0) || (classificazioniAteco?.length > 0) || (classificazioniIsco?.length > 0)">
        <h2 class="section-title">Referenziazioni</h2>

        <div class="list-section margin-bottom-20" *ngIf="classificazioniAda?.length > 0">
          <p class="width-100">
            <strong>ADA:</strong>
          </p>
          <mat-list>
            <mat-list-item *ngFor="let item of classificazioniAda">
              <strong>{{ item.codiceAda }}</strong> - {{ item.descrizione }}
            </mat-list-item>
          </mat-list>
        </div>

        <div class="list-section margin-bottom-20" *ngIf="classificazioniIstat?.length > 0">
          <p class="width-100">
            <strong>Classificazione Nazionale delle Professioni ISTAT:</strong>
          </p>
          <mat-list>
            <mat-list-item *ngFor="let item of classificazioniIstat">
              <strong>{{ item.codiceIstat }}</strong> - {{ item.nome }}
            </mat-list-item>
          </mat-list>
        </div>

        <div class="list-section margin-bottom-20" *ngIf="classificazioniAteco?.length > 0">
          <p class="width-100">
            <strong>Classificazione Nazionale delle Attività economiche ATECO:</strong>
          </p>
          <mat-list>
            <mat-list-item *ngFor="let item of classificazioniAteco">
              <strong>{{ item.codiceAteco }}</strong> - {{ item.descrizione }}
            </mat-list-item>
          </mat-list>
        </div>

        <div class="list-section margin-bottom-20" *ngIf="classificazioniIsco?.length > 0">
          <p class="width-100">
            <strong>Classificazione Internazionale delle Professioni ISCO:</strong>
          </p>
          <mat-list>
            <mat-list-item *ngFor="let item of classificazioniIsco">
              <strong>{{ item.codiceIsco }}</strong> - {{ item.descrizione }}
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Abilità e Conoscenze" *ngIf="datiCompetenza">
    <div class="page-padding">
      <h1 class="centered-title">Dettaglio Competenza: {{ datiCompetenza?.descrizione }}</h1>

      <div class="content-section">
        <h2 class="section-title">Elenco delle Conoscenze</h2>
        <mat-list>
          <mat-list-item *ngFor="let item of listaConoscenze">
            {{ item.descrizione }}
          </mat-list-item>
        </mat-list>
      </div>

      <div class="content-section">
        <h2 class="section-title">Elenco delle Abilità</h2>
        <mat-list>
          <mat-list-item *ngFor="let item of listaAbilita">
            {{ item.descrizione }}
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Elenco Profili Professionali" *ngIf="datiCompetenza && datiCompetenza?.tipologia?.id === 2">
    <h1 class="centered-title">Profili Professionali associati alla competenza</h1>
    <div>
      <table mat-table [dataSource]="dataSource">

        <!-- Position Column -->
        <ng-container matColumnDef="nomeProfilo">
          <th mat-header-cell *matHeaderCellDef> Nome Profilo</th>
          <td mat-cell *matCellDef="let element"> {{ element.nomeProfilo }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="descrizioneArea.descrizione">
          <th mat-header-cell *matHeaderCellDef> Area Professionale QRSP</th>
          <td mat-cell *matCellDef="let element"> {{ element.descrizioneArea.descrizione }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSize]="10" showFirstLastButtons [length]="paginatorSize"
                     aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </mat-tab>
</mat-tab-group>
